import { render, staticRenderFns } from "./BigScreen.vue?vue&type=template&id=2c07e8ca&scoped=true&"
import script from "./BigScreen.vue?vue&type=script&lang=js&"
export * from "./BigScreen.vue?vue&type=script&lang=js&"
import style0 from "./BigScreen.vue?vue&type=style&index=0&id=2c07e8ca&prod&lang=css&"
import style1 from "./BigScreen.vue?vue&type=style&index=1&id=2c07e8ca&prod&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c07e8ca",
  null
  
)

export default component.exports